import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { AppConstants } from '@/utils/constants';
import { setUserLocale, getDisplayLanguage, type Locale } from '@/utils/locale';

const LanguageSwitcher: FC = () => {
  const { i18n } = useTranslation();
  const currentLocale = i18n.language as Locale;

  const handleLanguageChange = (locale: Locale) => {
    i18n.changeLanguage(locale);
    setUserLocale(locale);
  };

  const menuItems: MenuProps['items'] =
    AppConstants.locale.availableLocales.map(locale => ({
      key: locale,
      label: getDisplayLanguage(locale, currentLocale),
      onClick: () => handleLanguageChange(locale),
    }));

  return (
    <Dropdown menu={{ items: menuItems }} placement="bottomRight">
      <Button
        type="text"
        icon={<GlobalOutlined />}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          marginRight: '8px',
          color: 'rgba(0, 0, 0, 0.88)',
        }}
      >
        {getDisplayLanguage(currentLocale, currentLocale)}
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
